import { FC } from 'react';
import { useBreakpoint, Breakpoints, NextgenImage, LoaderType } from '@nextgen-web-framework/all';
import { DesktopLayoutProps } from './types/propTypes';
import styles from './DesktopLayout.module.scss';

const DesktopLayout: FC<DesktopLayoutProps> = ({ children, imageClassName, desktopImage, containerClassName }) => {
  const breakpoint = useBreakpoint();
  const isDesktopView = ![Breakpoints.XS, Breakpoints.SM, Breakpoints.MD].includes(breakpoint as Breakpoints);
  return (
    <div className={`${styles['desktop-layout-container']} ${containerClassName}`} id="desktop-layout-container">
      <div className={styles['desktop-layout']} data-testid="desktop-layout">
        <div className={`${styles['desktop-layout-content']} ${isDesktopView ? styles['desktop'] : ''}`}>
          {children}
        </div>
        {isDesktopView && desktopImage && (
          <div
            className={`${styles['desktop-image']} ${imageClassName ?? styles['desktop-default-width']}`}
            data-testid="desktop-image"
          >
            <NextgenImage
              src={desktopImage?.url}
              loaderType={LoaderType.CONTENTSTACK}
              alt={desktopImage?.altText}
              fill={true}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DesktopLayout;
